import React from 'react';

import { useCuration } from '@hooks/useCuration';
import { useFeatureFlags } from '@hooks/useFeatureFlags';
import { useSession } from '@hooks/useSession';

import BaseLayout from './BaseLayout';
import useMenuLinks from './useMenuLinks';
import { processViewSettings } from './util';

const NON_PATIENT_USER_SETTINGS = [
  ['home', 'alerts', 'appInformation'],
] as const;

const NON_PATIENT_USER_SETTINGS_MOBILE = [['home', 'alerts']] as const;

const UserLayout: React.FC<{
  friendlyName?: string | null;
  children: React.ReactNode;
  showHeader?: boolean;
  loading?: boolean;
  mobile?: boolean;
  limitHeight?: boolean;
}> = ({
  friendlyName,
  children = null,
  showHeader = false,
  loading = false,
}) => {
  const {
    state: { patientView },
  } = useCuration();
  const {
    state: { activeProfile },
  } = useSession();
  const { flags } = useFeatureFlags();
  const { patientLinks } = useMenuLinks();

  const VIEW_PATIENT_SETTINGS = processViewSettings([
    [['backToClients', true]],
    [
      ['home', true],
      ['alerts', true],
      ['records', true],
      ['timeline', true],
      ['reminders', true],
      ['profile', true],
      ['contacts', true],
      ['assessments', flags.isAssessmentListAssessmentsEnabled],
      ['healthDevices', true],
      ['shareHistory', true],
      ['report', true],
      ['more', true],
      ['appInformation', true],
    ],
  ]);

  const VIEW_PATIENT_SETTINGS_MOBILE = processViewSettings([
    [
      ['home', true],
      ['alerts', true],
      ['records', true],
      ['timeline', true],
      ['routines', true],
      ['summary', true],
      ['assessments', flags.isAssessmentListAssessmentsEnabled],
      ['healthDevices', true],
      ['shareHistory', true],
    ],
  ]);

  return (
    <BaseLayout
      friendlyName={friendlyName}
      links={patientView ? patientLinks : undefined}
      loading={loading}
      showHeader={showHeader}
      settings={{
        desktop:
          patientView || activeProfile?.patient_id
            ? VIEW_PATIENT_SETTINGS
            : NON_PATIENT_USER_SETTINGS,
        mobile:
          patientView || activeProfile?.patient_id
            ? VIEW_PATIENT_SETTINGS_MOBILE
            : NON_PATIENT_USER_SETTINGS_MOBILE,
      }}
    >
      {children}
    </BaseLayout>
  );
};

export default UserLayout;
